import { render, staticRenderFns } from "./addGift.vue?vue&type=template&id=b1079702&scoped=true"
import script from "./addGift.vue?vue&type=script&lang=js"
export * from "./addGift.vue?vue&type=script&lang=js"
import style0 from "./addGift.vue?vue&type=style&index=0&id=b1079702&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1079702",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1079702')) {
      api.createRecord('b1079702', component.options)
    } else {
      api.reload('b1079702', component.options)
    }
    module.hot.accept("./addGift.vue?vue&type=template&id=b1079702&scoped=true", function () {
      api.rerender('b1079702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/addGift/addGift.vue"
export default component.exports